module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "ej--discovery-cover.2ebfad88.jpeg";